import axios from "axios";

export default class CEPService {

    static consultarCEP(cep) {
        return axios.get(`https://api.postmon.com.br/v1/cep/${cep}`);
    }
}
